module.exports = __webpack_public_path__ + "static/media/scan-qr-add-member.5829d70c.png";